import React, { useState } from 'react';
import './IntegrationModals.css';
import { FiFilter, FiX } from 'react-icons/fi';


const FilterModal = ({ isOpen, onClose, providers = [], currentFilters = {}, onApplyFilters }) => {
    const [filterChannel, setFilterChannel] = useState(currentFilters.channel || '');
    const [filterLabel, setFilterLabel] = useState(currentFilters.label || '');
    const [filterStatus, setFilterStatus] = useState(currentFilters.status || '');

    const handleApply = () => {
        onApplyFilters({
            channel: filterChannel,
            label: filterLabel,
            status: filterStatus
        });
        onClose();
    };

    const handleClear = () => {
        setFilterChannel('');
        setFilterLabel('');
        setFilterStatus('');
        onApplyFilters({
            channel: '',
            label: '',
            status: ''
        });
    };

    const handleClose = () => {
        setFilterChannel(currentFilters.channel || '');
        setFilterLabel(currentFilters.label || '');
        setFilterStatus(currentFilters.status || '');
        onClose();
    };

    if (!isOpen) return null;

    const hasActiveFilters = filterChannel || filterLabel || filterStatus;

    return (
        <div className="integration-modal-overlay" onClick={handleClose}>
            <div className="integration-modal integration-filter-modal" onClick={(e) => e.stopPropagation()}>
                <div className="integration-modal-header">
                    <div className="integration-modal-title-wrap">
                        <FiFilter className="integration-filter-icon" />
                        <h2>Filtrar Canais</h2>
                    </div>
                    <button className="integration-modal-close" onClick={handleClose}>×</button>
                </div>

                <div className="integration-modal-body">
                    <p className="integration-modal-description">
                        Filtre os canais conectados por tipo de canal ou rótulo personalizado.
                    </p>

                    <div className="integration-form-group">
                        <label htmlFor="filter-channel">Tipo de Canal</label>
                        <select
                            id="filter-channel"
                            className="integration-input"
                            value={filterChannel}
                            onChange={(e) => setFilterChannel(e.target.value)}
                        >
                            <option value="">Todos os canais</option>
                            {providers.map((provider) => (
                                <option key={provider.key} value={provider.key}>
                                    {provider.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="integration-form-group">
                        <label htmlFor="filter-label">Buscar por Rótulo</label>
                        <input
                            id="filter-label"
                            type="text"
                            className="integration-input"
                            value={filterLabel}
                            onChange={(e) => setFilterLabel(e.target.value)}
                            placeholder="Digite o nome do rótulo..."
                        />
                    </div>

                    <div className="integration-form-group">
                        <label htmlFor="filter-status">Status da Conexão</label>
                        <select
                            id="filter-status"
                            className="integration-input"
                            value={filterStatus}
                            onChange={(e) => setFilterStatus(e.target.value)}
                        >
                            <option value="">Todos os status</option>
                            <option value="connected">Apenas conectados</option>
                            <option value="credentials_saved">Credenciais cadastradas</option>
                        </select>
                    </div>

                    {hasActiveFilters && (
                        <div className="integration-filter-active">
                            <FiFilter size={14} />
                            <span>Filtros ativos</span>
                        </div>
                    )}
                </div>

                <div className="integration-modal-footer">
                    <button
                        type="button"
                        className="integration-btn integration-btn-secondary"
                        onClick={handleClear}
                        disabled={!hasActiveFilters}
                    >
                        <FiX size={16} />
                        Limpar Filtros
                    </button>
                    <button
                        type="button"
                        className="integration-btn integration-btn-primary"
                        onClick={handleApply}
                    >
                        Aplicar Filtros
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
